import React, { useEffect, useState } from "react";
import AxiosInstance from "../../../Services/axiosCommon";
import { Link, NavLink } from "react-router-dom";
import OfficeCard from "../../../Components/Cards/OfficeCard";
import Pagination from "../../../Components/Utils/Pagenation";

function OfficeIndex() {
  const [pageIndex, setPageIndex] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataCount, setDataCount] = useState(20);
  const [data, setData] = useState([]);

  function getData() {
    AxiosInstance.get(
      `/company_branch/?page=${pageIndex}&per_page=${dataCount}`
    )
      .then((res) => {
        res?.data?.data?.totalRecords &&
          setTotal(res?.data?.data?.totalRecords);
        res?.data?.data?.allCompanyBranch &&
          setData(res?.data?.data?.allCompanyBranch);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getData();
  }, [pageIndex, dataCount]);

  // const statusStyle = {
  //     color: status === 'active' ? 'green' : 'red',
  //   };

  return (
    <div className=" w-full h-full">
        <div className=" w-full h-[calc(100vh-170px)] overflow-y-auto p-3">
        <div className=" grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
        {data &&
          data.map((item) => {
            return (
              <>
                {" "}
                <Link
                  className=" text-gray-800 hover:text-gray-800 "
                  to={`/main/dashboard/${item.branchId}`}
                >
                  <OfficeCard
                    name={item?.branchName}
                    officeType={item?.branchType}
                    address={item?.country}
                    status={item?.isActive}
                    city={item?.city}
                  />
                </Link>{" "}
              </>
            );
          })}
      </div>
        </div>
      <div className=" w-full h-[30px] ">
        <Pagination
          total={total}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          dataCount={dataCount}
          setDataCount={setDataCount}
        />
      </div>
    </div>
  );
}

export default OfficeIndex;
